import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Hash, Play } from 'lucide-react';

export default function GameStart({ onStart, dailyWords, countdown, setCountdown }) {
  
  useEffect(() => {
    let timer;
    if (countdown !== null && countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    } else if (countdown === 0) {
      onStart();
    }
    return () => clearTimeout(timer);
  }, [countdown, onStart, setCountdown]);

  const handleStart = () => {
    setCountdown(3);
  };

  return (
    <div className="w-full max-w-2xl mx-auto space-y-6 px-4 py-8 animate-flip-in">
      <Card className="p-6 sm:p-8">
        {/* Header */}
        <div className="text-center mb-6">
          <h1 className="text-4xl sm:text-5xl font-bold mb-3 font-['Space_Grotesk'] bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
            Daily Challenge
          </h1>
          <p className="text-muted-foreground text-sm sm:text-base">
            Think fast. Type faster. Conquer the chaos.
          </p>
        </div>

        {/* Preview Today's Words */}
        <div className="space-y-3 py-3">
          <div className="flex items-center justify-center gap-2 text-muted-foreground">
            <Hash className="w-3 h-3" />
            <span className="text-xs font-medium">Today's Words - Keyboard Scrambles Each Word!</span>
          </div>
          <div className="flex flex-col gap-2 max-w-md mx-auto">
            {dailyWords.map((word, index) => (
              <div
                key={index}
                className="bg-muted/50 rounded-lg p-3 flex items-center justify-between"
              >
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center">
                    <span className="text-xs font-bold text-primary">{index + 1}</span>
                  </div>
                  <p className="text-lg font-bold font-['Space_Grotesk'] text-foreground">
                    {word.toUpperCase()}
                  </p>
                </div>
                <p className="text-xs text-muted-foreground font-medium">
                  {word.length} letters
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Start Button with Countdown */}
        <div className="pt-3">
          {countdown === null ? (
            <Button
              size="lg"
              onClick={handleStart}
              className="w-full bg-primary hover:bg-primary/90 text-lg font-semibold py-6"
            >
              <Play className="w-5 h-5 mr-2" />
              START CHALLENGE
            </Button>
          ) : countdown > 0 ? (
            <div className="text-center py-8">
              <div className="text-6xl sm:text-7xl font-bold text-primary animate-pulse font-['Space_Grotesk']">
                {countdown}
              </div>
              <p className="text-muted-foreground mt-2">Get ready...</p>
            </div>
          ) : null}
        </div>
      </Card>
    </div>
  );
}